import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import ReactPlayer from "react-player";

interface VideoModalProps {
  onClose: Function;
  shouldShow: boolean;
  url: any;
  type: any;
}

export default function VideoModal({ onClose, shouldShow, type, url }: VideoModalProps) {
  const [time, setTime] = useState<any>(5);
  const [intervalIds, setIntervalIds] = useState<any>([]);

  // useEffect(()=>{
  //     if(shouldShow) {
  //         let x:any = document.getElementById('promoVid')
  //         if(x) {
  //             x.play()
  //         }
  //     }
  // },[shouldShow])

  useEffect(() => {
    // if (type == "image") {
    //   setTimeout(() => onClose(), 5000);
    // }
  }, [type]);

  useEffect(() => {
    if (time == 0) {
      onClose();
      //   return;
    }
    let id = setInterval(() => {
      setTime(time - 1);
    }, 1000);
    let x = intervalIds?.length ? [...intervalIds] : [];
    x.push(id);
    setIntervalIds(x);
    // console.log({ id });
    return () => {
      let y = [...intervalIds];
      //   console.log({ y });
      y.map((i: any) => clearInterval(i));
    };
  }, [time]);

  return (
    <React.Fragment>
      <Modal
        show={shouldShow}
        backdrop="static"
        keyboard={false}
        className="dark-modal"
        centered
        contentClassName="custom-modal"
      >
        <Modal.Body>
          <div className="modal-body">
            {type == "image" && <h2>Promo image closes in {time} seconds...</h2>}
            {type == "video" ? (
              <video
                id="promoVid"
                src={url}
                preload="auto"
                autoPlay={true}
                muted={true}
                width="100%"
                height="100%"
                onEnded={() => onClose()}
              ></video>
            ) : (
              <img src={url} style={{ width: "100%" }} />
            )}
          </div>
        </Modal.Body>
        {type == "image" && (
          <Modal.Footer>
            <div className="btn-wrap mb-3 ">
              <button className="btn btn-primary theme-primary-btn w-100 mt-4" onClick={() => onClose()}>
                Close
              </button>
            </div>
          </Modal.Footer>
        )}
      </Modal>
    </React.Fragment>
  );
}
